import React, { useState, useEffect, useMemo } from "react";
import {
  ActionLevelRestriction,
  UpdateRestrictionPermission,
  getCreateRole,
  getroutinglevelsCountry,
  getroutinglevelsRegion,
} from "../../API/api";
import { Space, Table, Spin, Tooltip, Popconfirm, Checkbox, theme } from "antd";
import TitleValue from "../cmOverview/tabs/seeker/TitleValue";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectCm from "../MultiSelectCm/MultiSelectCm";
import RegionSelection, { isEmptyObject } from "./RegionSelection";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import VizButton from "../VizButtons/VizButton";
import styles from "./Restriction.module.css";
import { SearchBar } from "../AdminManageRole/AdminManageRole";
import { cleanFilterItem } from "@mui/x-data-grid/hooks/features/filter/gridFilterUtils";
import VizHeader from "../VizHeader/VizHeader";
import { SearchOutlined, SyncOutlined } from "@ant-design/icons";
const filtering = (row, text) => {
  return (
    row &&
    row?.filter((row) =>
      Object.values(row)?.some((value) =>
        value
          ?.toString()
          .toLowerCase()
          .includes(text?.toString()?.toLowerCase())
      )
    )
  );
};
function compareCountryToRegion(region, country) {
  let result = [];
  for (let key in country) {
    if (region[key] === 1 && country[key] === 1) {
      result.push(key.toString()); // Ensure keys are integers
    }
  }
  return result;
}
function getRegionAndCountryObject(actionLevelRestriction, region, country) {
  let result = {};

  // Find the level containing the region
  for (let level in actionLevelRestriction) {
    if (actionLevelRestriction[level][region]) {
      result.region = actionLevelRestriction[level][region];
    }
    if (actionLevelRestriction[level][country]) {
      result.country = actionLevelRestriction[level][country];
    }
  }

  return result;
}

function overrideRegionWithCountry(region, country) {
  // Iterate over each key in the country object
  for (let key in country) {
    // Override the value in the region object if the key exists
    region[key] = country[key];
  }
  return region;
}
export const isObjectDefinedAndNotNull = (obj) => {
  return typeof obj === "object" && obj !== null;
};

function RestrictPermission() {
  const [permission, setPermission] = useState(null);
  const [loading, setLoading] = useState(true);
  const [actionLevelRestriction, setActionLevelRestriction] = useState(null);
  const [routingLevels, setRoutingLevels] = useState(null);
  const state = useSelector((state) => state.restrictPermission);
  const dispatch = useDispatch();
  const [searchPermission, setSearchPermission] = useState("");
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [selectedObj, setSelectedObj] = useState([]);
  const [checkRow, setCheckedRow] = useState([]);
  const [selectCountryCheckbox, setSelectCountryCheckBox] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [updateValue, setUpdateValue] = useState(false);
  const [regionName, setRegionName] = useState("");
  const [countryObj, setCountryObj] = useState(null);
  const {
    GetCountryValuesAction,
    SelectedCountryValueAction,
    ActionRestrictionValue,
    selectRegionAction,
    // SelectedCountryValueAction,
    CountryActionBoolean,
  } = bindActionCreators(Actions, dispatch);

  const fetchCountryData = (parent) => {
    getroutinglevelsCountry(parent).then((res) => {
      setLoading(false);
      if (!state?.countrySelectBoolean) {
        SelectedCountryValueAction(null);
      }

      GetCountryValuesAction(res);
      CountryActionBoolean(false);
    });
  };
  const fetchData = () => {
    setLoading(true);
    getCreateRole().then((res) => {
      setPermission(res);
      setLoading(false);
    });
    ActionLevelRestriction((res) => {
      setSelectedObj(res?.restriction);
      ActionRestrictionValue(res);
      setActionLevelRestriction(res);
    });
    getroutinglevelsRegion((res) => {
      setRoutingLevels(res);
    });
  };
  useEffect(() => {
    fetchData();
  }, []);
  // useEffect(() => {}, []);
  useEffect(() => {
    // if()
    setCheckedRow([]);
    setSelectCountryCheckBox([]);
    setLoading(true);
    fetchCountryData(state?.SelectedRegionValue?.name);
  }, [state?.SelectedRegionValue]);

  // const keyData =
  //   actionLevelRestriction &&
  //   actionLevelRestriction[
  //     state?.selectedCountryValue == null || undefined ? 2 : 1
  //   ][
  //     state?.selectedCountryValue?.name !== null || undefined
  //       ? state?.selectedCountryValue?.name?.toString()
  //       : state?.SelectedRegionValue?.name?.toString()
  //   ];

  const updateCheckBox = () => {
    if (
      actionLevelRestriction !== null ||
      isObjectDefinedAndNotNull(actionLevelRestriction)
    ) {
      const countryDataObject =
        actionLevelRestriction &&
        actionLevelRestriction["1"] !== undefined &&
        state?.selectedCountryValue?.name?.toString() !== undefined
          ? actionLevelRestriction["1"][
              state?.selectedCountryValue?.name?.toString()
            ] !== undefined
            ? actionLevelRestriction["1"][
                state?.selectedCountryValue?.name?.toString()
              ]
            : state?.selectedCountryValue?.name?.toString()
          : "";

      const RegionDataObject =
        actionLevelRestriction &&
        actionLevelRestriction["2"] !== undefined &&
        state?.SelectedRegionValue?.name?.toString() !== undefined
          ? actionLevelRestriction["2"][
              state?.SelectedRegionValue?.name?.toString()
            ]
          : "";

      let val =
        RegionDataObject &&
        Object.entries(RegionDataObject)?.map((item) => item[0]);
      let countryVal =
        countryDataObject &&
        Object.entries(countryDataObject)?.map((item) => item[0]);
      let set = Array.from(new Set(val));

      let countryValues =
        actionLevelRestriction["1"] !== undefined
          ? Object.keys(actionLevelRestriction["1"])
          : [];
      let regionValues =
        actionLevelRestriction["2"] !== undefined
          ? Object.keys(actionLevelRestriction["2"])
          : [];
      // let arr=
      let checked =
        RegionDataObject &&
        Object.entries(RegionDataObject)
          .filter(([key, value]) => value === 1)
          .map(([key, value]) => key?.toString());
      // setSelectCountryCheckBox
      let countryChecked =
        countryDataObject &&
        Object.entries(countryDataObject)
          .filter(([key, value]) => value === 1)
          .map(([key, value]) => key?.toString());

      setCheckedRow(checked);
      if (state?.selectedCountryValue?.name !== undefined) {
        // setCheckedRow([]);

        // parent values inheriting the child
        if (
          checked?.length > 0 &&
          countryValues?.includes(state?.selectedCountryValue?.name)
        ) {
          // let regionObj=
          let regionAndCountryObject = getRegionAndCountryObject(
            actionLevelRestriction,
            state?.SelectedRegionValue?.name,
            state?.selectedCountryValue?.name
          );

          let newArray = overrideRegionWithCountry(
            { ...regionAndCountryObject.region },
            regionAndCountryObject.country
          );
          let updatedCheck = Object.entries(newArray)
            .filter(([key, value]) => value === 1)
            .map(([key, value]) => key?.toString());
          setSelectCountryCheckBox(updatedCheck);
        }
        if (
          checked?.length > 0 &&
          countryChecked?.length === 0 &&
          !countryValues?.includes(state?.selectedCountryValue?.name)
        ) {
          setSelectCountryCheckBox([...checked]);
        }
        // if the parent has no restriction and selected is not there is the recieved data of api.
        if (
          checked?.length === 0 &&
          countryChecked?.length === 0 &&
          !countryValues?.includes(state?.selectedCountryValue?.name)
        ) {
          setSelectCountryCheckBox([]);
        }
        if (
          checked?.length === 0 &&
          countryChecked?.length === 0 &&
          countryValues?.includes(state?.selectedCountryValue?.name)
        ) {
          setSelectCountryCheckBox(countryChecked);
        }
        // if the parent has no restriction and selected country is the in the received data of API.
        if (
          checked?.length === 0 &&
          countryChecked?.length > 0 &&
          countryValues?.includes(state?.selectedCountryValue?.name)
        ) {
          setSelectCountryCheckBox([...countryChecked]);
        }
      }
      setRegionData(RegionDataObject);
      setCountryData(countryDataObject);
      setCountryObj(RegionDataObject);
      setSelectedKeys(set);
    }
  };

  useEffect(() => {
    updateCheckBox();
  }, [state?.SelectedRegionValue, state?.selectedCountryValue, updateValue]);

  // useEffect(() => {
  //   // Extract keys with value 1 from keyData
  //   const checked =
  //     keyData &&
  //     Object.entries(keyData)
  //       .filter(([key, value]) => value === 1)
  //       .map(([key, value]) => key.toString());

  //   setCheckedRow(checked);
  // }, [state?.SelectedRegionValue, state?.selectedCountryValue]);
  const handleCheckboxChange = (key) => {
    if (state?.selectedCountryValue?.name === undefined) {
      setCheckedRow((prevSelectedKeys) => {
        let value = prevSelectedKeys === undefined ? [] : prevSelectedKeys;
        if (value?.includes(key.toString())) {
          return value?.filter((checkRow) => {
            return checkRow?.toString() !== key.toString();
          });
        } else {
          return [...value, key];
        }
      });
      //
    } else {
      setSelectCountryCheckBox((item) => {
        let prevSelectedKeys = item === undefined ? [] : item;
        if (prevSelectedKeys && prevSelectedKeys?.includes(key?.toString())) {
          return (
            prevSelectedKeys &&
            prevSelectedKeys?.filter((checkRow) => {
              return checkRow?.toString() !== key.toString();
            })
          );
        } else {
          return [...prevSelectedKeys, key];
        }
      });
    }
  };

  const column = useMemo(
    () => [
      {
        title: TitleValue("Id"),
        dataIndex: "id",
        sorter: (a, b) => a.index - b.index,
        defaultSortOrder: "ascend",
        align: "center",
        width: 40,
        render: (_, raw) => (
          <span
            style={{
              wordBreak: 'break-word',overflowWrap: 'break-word',
              fontSize: "15px",
              fontWeight: "300",
              display: "flex",
              width: "50%",
              justifyContent: "flex-end",
              textAlign: "right",
            }}
          >
            {raw.index + 1}
          </span>
        ),
      },
      {
        title: TitleValue("Permission"),
        dataIndex: "name",
        sorter: (a, b) => a.name.localeCompare(b.name),
        align: "left",
        width: 250,
        render: (_, raw) => (
          <span
            style={{
              wordBreak: 'break-word',overflowWrap: 'break-word',
              fontSize: "15px",
              fontWeight: "300",
            }}
          >
            {raw.name}
          </span>
        ),
      },
    ],
    [permission]
  );
  const keysArray = Object.entries(selectedKeys)
    .filter(([key, value]) => value === 1)
    .map(([key, value]) => key);
  const RegionValueColumn = {
    title: TitleValue(state?.SelectedRegionValue?.name),
    dataIndex: state?.SelectedRegionValue?.name,
    key: state?.SelectedRegionValue?.name,
    width: 100,
    render: (_, record) => (
      <Checkbox
        key={record.id}
        checked={
          checkRow?.length > 0 && checkRow?.includes(record.id?.toString())
        }
        disabled={
          state?.selectedCountryValue?.name === undefined ? false : true
        }
        onChange={() => handleCheckboxChange(record.id?.toString())}
      />
    ),
  };

  const countryColumn = {
    title: TitleValue(state?.selectedCountryValue?.name),
    dataIndex: state?.selectedCountryValue?.name,
    key: state?.selectedCountryValue?.name,
    width: 100,
    render: (_, record) => (
      <Checkbox
        key={record.id}
        checked={
          selectCountryCheckbox?.length > 0 &&
          selectCountryCheckbox?.includes(record.id?.toString())
        }
        onChange={() => handleCheckboxChange(record.id?.toString())}
      />
    ),
  };

  let columnData = [...column];
  if (state?.SelectedRegionValue !== null || undefined) {
    columnData.push(RegionValueColumn);
  }
  if (state?.selectedCountryValue !== null || undefined) {
    columnData.push(countryColumn);
  }
  const permissionData = useMemo(() => {
    return permission?.map((item, index) => ({ ...item, index }));
  }, [permission]);

  const searchRecord = (event) => {
    setSearchPermission(event.target.value);
  };

  const EditPermission = (region, country, countryObj) => {
    let value =
      state?.selectedCountryValue?.name === undefined
        ? checkRow
        : selectCountryCheckbox;
    // let set = new Set(val);
    const arrSet = new Set(value);
    let obj1 =
      state?.selectedCountryValue?.name === undefined ? region : country;
    // for (let key in obj1) {
    //   if (!value.includes(key)) {
    //     obj1[key] = 0;
    //   }
    // }

    // let newData = {
    //   [obj1]: value?.reduce((acc, curr) => {
    //     acc[curr] = 1;

    //     return acc;
    //   }, {}),
    // };
    // let newData = {
    //   [obj1]: Object.keys(region).reduce((acc, key) => {
    //     acc[key] = value.includes(key) ? 1 : 0;
    //     return acc;
    //   }, {}),
    // };

    try {
      if (!region || !obj1) {
        throw new Error("Required data is missing");
      }

      var newData = {
        [obj1]: Object.keys(region).reduce((acc, key) => {
          acc[key] = value.includes(key) ? 1 : 0;
          return acc;
        }, {}),
      };
    } catch (error) {
      console.error("An error occurred:", error);
    }
    let obj =
      typeof obj1 === "object" && obj1 !== undefined
        ? obj1
        : newData !== undefined
        ? newData[obj1?.toString()]
        : {};

    value &&
      value?.forEach((item) => {
        if (obj[item] !== undefined) {
          obj[item] = 1; // Set value to 1 if item exists in obj keys
        } else {
          obj[item] = 1; // Add item to obj with value 1 if it does not exist in obj keys
        }
      });

    // Set value to 0 for keys in obj that are not in arr
    obj !== undefined &&
      Object.keys(obj)?.forEach((key) => {
        if (!arrSet.has(key.toString())) {
          return (obj[key] = 0);
        }
      });

    const updatedObject = { ...actionLevelRestriction };

    // function to update the data....
    const updateWholeObject = (obj, region, country, newObject) => {
      let obj1 = state?.RegionValues;

      // if (obj.hasOwnProperty(region.toString())) {
      //   // If the country exists within the region, merge the new object
      //   if (obj[region.toString()].hasOwnProperty(country)) {
      //     obj[region.toString()][country] = {
      //       ...obj[region.toString()][country],
      //       ...newObject,
      //     };
      //   } else {
      //     // Otherwise, create the country and assign newObject
      //     obj[region.toString()][country] = newObject;
      //   }
      // } else {
      //   // If region is not a key, create the region and assign newObject
      //   obj[region.toString()] = {
      //     [country]: newObject,
      //   };
      // }

      if (obj.hasOwnProperty(region.toString())) {
        // If the region exists, append the newObject inside the region
        obj[region.toString()] = {
          ...obj[region.toString()],
          [country]: newObject,
        };
      } else {
        // If region is not a key, create the region and assign newObject
        obj[region.toString()] = {
          [country]: newObject,
        };
      }

      if (typeof obj === "object" && isEmptyObject(obj)) {
        // Initialize objValue with obj
        let objValue = { ...obj };

        // Ensure the nested structure exists
        if (!objValue[region.toString()]) {
          objValue[region.toString()] = {};
        }

        // Update the nested object
        objValue[region.toString()][country] = newObject;

        // Update the original obj with the new values
        obj = objValue;
        return obj;
      }

      if (typeof obj1 !== "object" && obj1 !== undefined) {
        obj[region][country] = newObject;
        return obj;
      }
      return obj;
    };
    // [state?.selectedCountryValue == null || undefined ? 2 : 1][
    //   state?.SelectedRegionValue?.name !== null || undefined
    //     ? state?.SelectedRegionValue?.name?.toString()
    //     : state?.selectedCountryValue?.name?.toString()
    // ];
    let countryVal =
      state?.selectedCountryValue?.name !== undefined
        ? state?.selectedCountryValue?.name?.toString()
        : state?.SelectedRegionValue?.name?.toString();

    let payload = updateWholeObject(
      updatedObject,
      state?.selectedCountryValue?.name == null || undefined ? 2 : 1,
      countryVal,
      obj !== undefined ? obj : {}
    );

    let newPayloadData = { restrictions: payload };
    setLoading(true);
    UpdateRestrictionPermission(newPayloadData).then((res) => {
      setLoading(false);
      setActionLevelRestriction(res?.data?.data?.restrictions);
      ActionRestrictionValue(res?.data?.data?.restrictions);
      setUpdateValue(!updateValue);

      // setActionLevelRestriction(res?.data?.data?.restrictions);
    });
  };

  const refreshData = () => {
    // setRefresh(!refresh);
    selectRegionAction(null);
    SelectedCountryValueAction(null);
    fetchData();
  };
  return (
    <>
      <Spin
        spinning={loading}
        style={{
          width: "100%",
        }}
      >
        {" "}
        <div className={styles.tableParent}>
          <div>
            <RegionSelection
              actionLevelRestriction={actionLevelRestriction}
              setRegionName={setRegionName}
            />
          </div>
          <div
            className={styles.header}
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              padding: "15px",
              justifyContent: "space-between",
              marginTop: "15px",
            }}
          >
            <div
              style={{
                width: "58%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>
                <SearchBar
                  searchValue={searchPermission}
                  handleSearch={searchRecord}
                  setSearchValue={setSearchPermission}
                  // setCurrentPage={setCurrentPage}
                />
              </span>
              <span>
                <div
                  style={{
                    fontSize: "20px",
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "500",
                    textTransform: "none",
                  }}
                >
                  List of Restrict Permissions&nbsp;
                </div>
                {/* <VizHeader type={4} isBold={true}>
                  List of Restrict Permissions
                </VizHeader> */}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "40%",
                justifyContent: "end",
              }}
            >
              <span style={{ marginRight: "10px" }}>
                <VizButton
                  size={2}
                  type={
                    state?.selectedCountryValue?.name !== undefined ||
                    state?.SelectedRegionValue?.name !== undefined
                      ? "Primary"
                      : "Disabled"
                  }
                  onClick={() =>
                    EditPermission(regionData, countryData, countryObj)
                  }
                  // onClick={createRole ? CreateRoleFun : EditRolePermission}
                >
                  {/* {createRole ? "Create" : "Update"} Role */}
                  Update
                </VizButton>
              </span>
              <span>
                <Tooltip
                  color="#fff"
                  title={() => {
                    return (
                      <span
                        style={{ color: "black", textTransform: "capitalize" }}
                      >
                        Refresh
                      </span>
                    );
                  }}
                >
                  <SyncOutlined
                    colSpan={3}
                    span={2}
                    onClick={() => refreshData()}
                    spin={loading}
                    style={{ fontSize: "16px" }}
                  />
                </Tooltip>
              </span>
            </div>
          </div>{" "}
          <style jsx>
            {`
              .ant-table-thead th:nth-child(0) {
                z-index: 0;
              }
            `}{" "}
          </style>
          <style jsx>
            {`
              .ant-table-thead th:nth-child(1) {
                z-index: 0;
              }
            `}{" "}
          </style>
          <style jsx>
            {`
              .ant-table-thead th:nth-child(2) {
                z-index: 0;
              }
            `}{" "}
          </style>
          <style jsx>
            {`
              .ant-table-thead th:nth-child(3) {
                z-index: 0;
              }
            `}{" "}
          </style>
          <style jsx>
            {`
              .ant-table-thead th:nth-child(4) {
                z-index: 0;
              }
            `}{" "}
          </style>
          <style jsx>
            {`
              .ant-table-thead th:nth-child(5) {
                z-index: 0;
              }
            `}{" "}
          </style>
          <style jsx>
            {`
              .ant-table-thead th:nth-child(6) {
                z-index: 0;
              }
            `}{" "}
          </style>
          <style jsx>
            {`
              .ant-table-thead th:nth-child(7) {
                z-index: 0;
              }
            `}{" "}
          </style>
          <Table
            columns={columnData}
            rowClassName={(record, index) =>
              index % 2 === 0 ? "table-row-light" : "table-row-dark"
            }
            dataSource={filtering(permissionData, searchPermission)}
            showSorterTooltip={false}
            // rowSelection={{}}
            pagination={false}
            scroll={{ y: 500 }}
            rowKey="id"
            style={{ marginTop: "10px" }}
            bordered
            // rowSelection={!rolesEdit ? undefined  : { rowSelection }}
          />
        </div>
      </Spin>
    </>
  );
}

export default RestrictPermission;
